import { useState } from "react";

function useReorderItems(initialItems) {
    const [items, setItems] = useState(initialItems || []);
    const [draggedIndex, setDraggedIndex] = useState(null);

    const onDragStart = (index) => {
        setDraggedIndex(index);
    };

    const onDragOver = (index) => {
        if (draggedIndex === null || draggedIndex === index) return;

        const reorderedItems = [...items];
        const draggedItem = reorderedItems[draggedIndex];

        reorderedItems.splice(draggedIndex, 1);
        reorderedItems.splice(index, 0, draggedItem);

        setDraggedIndex(index);
        setItems(reorderedItems);
    };

    const onDrop = () => {
        setDraggedIndex(null);
    };

    // Touch event handlers
    const onTouchStart = (index) => {
        setDraggedIndex(index);
    };

    const onTouchMove = (event, index) => {
        if (draggedIndex === null || draggedIndex === index) return;

        // Prevent default scrolling behavior
        event.preventDefault();

        const touchLocation = event.targetTouches[0];
        const targetElement = document.elementFromPoint(
            touchLocation.clientX,
            touchLocation.clientY
        );

        if (targetElement) {
            const targetIndex = parseInt(
                targetElement.getAttribute("data-index"),
                10
            );

            if (targetIndex >= 0 && targetIndex !== draggedIndex) {
                onDragOver(targetIndex);
            }
        }
    };

    const onTouchEnd = () => {
        setDraggedIndex(null);
    };

    return {
        items,
        onDragStart,
        onDragOver,
        onDrop,
        onTouchStart,
        onTouchMove,
        onTouchEnd,
    };
}

export default useReorderItems;
